// extracted by mini-css-extract-plugin
export var equalColumn = "_gc-0";